<template>
<div>
    
    <div class="div_f_001" v-if="!isMobile">
        <div>
            <div class="div_001_l">
                <div> MinewayTech </div>
                <div>
                    <div>Contact</div>
                    <div>+86 13818663162</div>
                    <div>+61 481234823</div>
                    <div>michael.meng@yiwang.com.cn</div>
                </div>
                <div>
                    <div>Address</div>
                    <div>Wanshow Tower, Room 2001</div>
                    <div>198 Jingzhou Rd, Yangpu District</div>
                    <div>Shanghai, PRC</div>
                </div>
                <div>
                    <div>Social Media</div>
                    <div>Wechat</div>
                    <div>Youtube</div>
                    <div>Instagram</div>
                </div>
            </div>
            <div class="div_001_r">
                <div></div>
                <div></div>
                <div> Add WeChat to obtain detailed information and samples </div>
            </div>
        </div>
        <div></div>
        <div>
            <div>
                <div>Legal statement</div>
                <div>Privacy policy</div>
                <div>Cookie Policy</div>
            </div>
            <div>Copyright © August 2025, MINEWAYTECH A/S, 沪ICP备2023094392号-1</div>
        </div>
    </div>
    
    <div class="div_mobile_f_001" v-if="isMobile">
        <div>
            <div class="div_mobile_001_l">
                <div> MinewayTech </div>
                <div>
                    <div>Contact</div>
                    <div>+86 13818663162</div>
                    <div>+61 481234823</div>
                    <div>michael.meng@yiwang.com.cn</div>
                </div>
                <div>
                    <div>Address</div>
                    <div>Wanshow Tower, Room 2001</div>
                    <div>198 Jingzhou Rd, Yangpu District</div>
                    <div>Shanghai, PRC</div>
                </div>
                <div>
                    <div>Social Media</div>
                    <div>Wechat</div>
                    <div>Youtube</div>
                    <div>Instagram</div>
                </div>
            </div>
            <div class="div_mobile_001_r">
                <div></div>
                <div></div>
                <div> Add WeChat to obtain detailed information and samples </div>
            </div>
        </div>
        <div></div>
        <div>
            <div>
                <div>Legal statement</div>
                <div>Privacy policy</div>
                <div>Cookie Policy</div>
            </div>
            <div>Copyright © August 2025, MINEWAYTECH A/S, 沪ICP备2023094392号-1</div>
        </div>
    </div>
    
</div>
</template>

<script>
export default {
    data() {
        return {
            isMobile     : false,
            screenHeight : 0,
            scrollTop    : 0,
        };
    },
    created() {
        // 监听；
        window.addEventListener('resize', this.checkIsMobile);
        // window.addEventListener('scroll', this.checkScrollTop);
    },
    mounted() {
        let that = this;
        
        document.title = '';
        
        this.checkIsMobile();
        this.checkScreenHeight();
    },
    destroyed() {
        window.removeEventListener('resize', this.checkIsMobile);
        // window.removeEventListener('scroll', this.checkScrollTop);
    },
    methods: {
        // 检测移动设备；
        checkIsMobile() {
            const width = window.innerWidth || document.documentElement.clientWidth;
            let isMobile_001 = width <= 768;
            
            const userAgent = window.navigator.userAgent;
            let isMobile_002 = /iPhone|iPad|iPod|Android/i.test(userAgent);
             
            this.isMobile = isMobile_001 || isMobile_002;
            
            // console.log("移动设备判断方式一：", isMobile_001);
            // console.log("移动设备判断方式二：", isMobile_002);
        },
        // 检测屏幕高度；
        checkScreenHeight() {
            const height = window.innerHeight || document.documentElement.clientHeight;
            this.screenHeight = height;
        },
        // 事件 - 导航栏跳转；
        nav_001( param ) {
            this.$router.push( "/" + param );
        },
    }
};
</script>

<style scoped>
/*** ************************************************* ***/

.div_f_001 {
    width: 100%;
    height: 330px;
    background-color: #151513;
    
    font-family: 'Source Han Sans CN';
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_f_001 > div:first-child {
    width: 1440px;
    height: 132px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_001_l {
    width: 1000px;
    height: 100%;
    
    color: #F7F4EC;
    font-size: 14px;
    
    display : flex;
    flex-direction : row;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_001_l > div:first-child {
    width: 147px;
    height: 100%;
    
    font-weight: 600;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_001_l > div:nth-child(2) {
    width: 247px;
    height: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_001_l > div:nth-child(3) {
    width: 247px;
    height: 100%;
    
    margin-left: 56px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_001_l > div:last-child {
    width: 247px;
    height: 100%;
    
    margin-left: 56px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_001_l > div:nth-child(2) > div:nth-child(2),
.div_001_l > div:nth-child(3) > div:nth-child(2),
.div_001_l > div:last-child   > div:nth-child(2) {
    cursor: pointer;
    margin-top: 24px;
}

.div_001_l > div:nth-child(2) > div:nth-child(3),
.div_001_l > div:nth-child(2) > div:last-child,
.div_001_l > div:nth-child(3) > div:nth-child(3),
.div_001_l > div:nth-child(3) > div:last-child,
.div_001_l > div:last-child   > div:nth-child(3),
.div_001_l > div:last-child   > div:last-child  {
    cursor: pointer;
    margin-top: 14px;
}

.div_001_r {
    width: 300px;
    height: 200px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    
    position: relative;
}

.div_001_r > div:first-child   {
    width: 130px;
    height: 130px;
    
    border-radius: 2px;
    
    cursor: pointer;
    
    background-image : url('../assets/QRcide_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_001_r > div:nth-child(2) {
    width: 130px;
    height: 130px;
    
    border-radius: 2px;
    
    cursor: pointer;
    
    background-image : url('../assets/QRcide_002.jpg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_001_r > div:last-child {
    width: 300px;
    
    font-size: 11px;
    color: #F7F4EC;
    
    text-align: left;
    
    position: absolute;
    bottom: 4px;
    left: 0px;
}

/*** ************************************************* ***/

.div_f_001 > div:nth-child(2) {
    width: 1440px;
    height: 0px;
    
    margin: 44px auto;
    
    border-top: 1px solid #7D7D7D;
}

/*** ************************************************* ***/

.div_f_001 > div:last-child {
    width: 1440px;
    height: 14px;
    
    font-size: 10px;
    color: #7D7D7D;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_f_001 > div:last-child > div:first-child {
    width: 283px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_f_001 > div:last-child > div:first-child > div {
    cursor: pointer;
}

.div_f_001 > div:last-child > div:last-child {
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

/*** ************************************************* ***/

/*** ************************************************* ***/

.div_mobile_f_001 {
    width: 100%;
    background-color: #151513;
    
    font-family: 'Source Han Sans CN';
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

/*** ************************************************* ***/

.div_mobile_f_001 > div:first-child {
    width: 100%;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_001_l {
    width: 100%;
    
    color: #F7F4EC;
    font-size: 14px;
    
    display : flex;
    flex-direction : column;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_001_l > div:first-child {
    width: 147px;
    height: 100%;
    
    font-weight: 600;
    
    margin-top: 35px;
    
    display : flex;
    flex-direction : column;
    justify-content : center;
    align-items : center;
}

.div_mobile_001_l > div:nth-child(2) {
    width: 247px;
    height: 100%;
    
    margin-top: 35px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_001_l > div:nth-child(3) {
    width: 247px;
    height: 100%;
    
    margin-top: 35px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_001_l > div:last-child {
    width: 247px;
    height: 100%;
    
    margin-top: 30px;
    
    display : flex;
    flex-direction : column;
    justify-content : flex-start;
    align-items : flex-start;
}

.div_mobile_001_l > div:nth-child(2) > div:nth-child(2),
.div_mobile_001_l > div:nth-child(3) > div:nth-child(2),
.div_mobile_001_l > div:last-child   > div:nth-child(2) {
    cursor: pointer;
    margin-top: 24px;
}

.div_mobile_001_l > div:nth-child(2) > div:nth-child(3),
.div_mobile_001_l > div:nth-child(2) > div:last-child,
.div_mobile_001_l > div:nth-child(3) > div:nth-child(3),
.div_mobile_001_l > div:nth-child(3) > div:last-child,
.div_mobile_001_l > div:last-child   > div:nth-child(3),
.div_mobile_001_l > div:last-child   > div:last-child  {
    cursor: pointer;
    margin-top: 14px;
}

.div_mobile_001_r {
    width: 100%;
    height: 200px;
    
    display : flex;
    flex-direction : row;
    justify-content : center;
    align-items : center;
    
    position: relative;
}

.div_mobile_001_r > div:first-child   {
    width: 130px;
    height: 130px;
    
    border-radius: 2px;
    
    cursor: pointer;
    
    background-image : url('../assets/QRcide_001.png');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_001_r > div:nth-child(2) {
    width: 130px;
    height: 130px;
    
    border-radius: 2px;
    
    cursor: pointer;
    
    margin: 0px 10px;
    
    background-image : url('../assets/QRcide_002.jpg');
    background-repeat : no-repeat;
    background-position : center;
    background-size : 100%;
}

.div_mobile_001_r > div:last-child {
    width: 300px;
    
    font-size: 11px;
    color: #F7F4EC;
    
    text-align: center;
    
    position: absolute;
    bottom: 4px;
}

/*** ************************************************* ***/

.div_mobile_f_001 > div:nth-child(2) {
    width: 80%;
    height: 0px;
    
    margin: 20px auto;
    
    border-top: 1px solid #7D7D7D;
}

/*** ************************************************* ***/

.div_mobile_f_001 > div:last-child {
    width: 100%;
    height: 50px;
    
    padding-bottom: 20px;
    
    font-size: 10px;
    color: #7D7D7D;
    
    display : flex;
    flex-direction : column;
    justify-content : space-around;
    align-items : center;
}

.div_mobile_f_001 > div:last-child > div:first-child {
    width: 283px;
    
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

.div_mobile_f_001 > div:last-child > div:last-child {
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
}

/*** ************************************************* ***/
</style>